import React, { useState, useEffect } from "react"

import { ResultsContextProvider } from "./resultscontext/resultscontext"

import Section from "../section/section"
import ResultsHeader from "./resultsheader/resultsheader"
import ResultsHeaderStats from "./resultsheader/resultsheaderstats"
import ResultsSlider from "./resultsslider/resultsslider"
import ResultsStats from "./resultsstats/resultsstats"
import ResultsDisclaimer from "./resultsdisclaimer/resultsdisclaimer"

import { ButtonNova } from "@nutrafol/nutrafol-ui-kit/dist/ButtonNova"
import { Box } from "@rebass/grid/emotion"

const Results = ({ data }) => {
  const { header, slider, stats, button, footerDisclaimer } = data

  const [isRendered, setIsRendered] = useState(false)

  useEffect(() => {
    setIsRendered(true)
  }, [])

  if (!isRendered) {
    return null
  }

  return (
    <ResultsContextProvider>
      <Section>
        {header && !stats ? (
          <ResultsHeader
            slides={slider.slides}
            {...header}
            direction={slider?.cardDirection}
          />
        ) : null}
        {header && stats ? (
          <ResultsHeaderStats
            slides={slider.slides}
            stats={stats}
            {...header}
          />
        ) : null}
        {slider ? <ResultsSlider {...slider} /> : null}
        {stats ? (
          <div className="hide-lg-up">
            <ResultsStats {...stats} />
          </div>
        ) : null}
        {footerDisclaimer ? (
          <ResultsDisclaimer data={footerDisclaimer} className="text-center" />
        ) : null}
        {button ? (
          <Box width={[1]} mt={[32, 32, 40, 80]}>
            <ButtonNova {...button} />
          </Box>
        ) : null}
      </Section>
    </ResultsContextProvider>
  )
}

export default Results
